import {h} from 'preact/dist/preact';
import {SelectField} from '@components/common/Form/SelectField';
import {TextField} from '@components/common/Form/TextField';
import {usStateList} from '@util/USStateList';

const AddressFormFields = ( {values, errors, touched, handleSubmit, handleChange} ) =>
    <fieldset className="mt-0">
        <ol>
            <li>
                <TextField
                    id="address1"
                    label="Address Street*"
                    autocorrect="off"
                    spellcheck="false"
                    onChange={handleChange}
                    error={touched.address1 && errors.address1}
                    value={values.address1}
                    inputClassName="w-full"
                    className="mt-2"/>
            </li>
            <li>
                <TextField
                    id="address2"
                    label="Address 2 (optional)"
                    autocorrect="off"
                    spellcheck="false"
                    onChange={handleChange}
                    error={touched.address2 && errors.address2}
                    value={values.address2}
                    inputClassName="w-full"
                    className="mt-2"/>
            </li>
            <li>
                <TextField
                    id="city"
                    label="City*"
                    autocorrect="off"
                    spellcheck="false"
                    onChange={handleChange}
                    error={touched.city && errors.city}
                    value={values.city}
                    inputClassName="w-full"
                    className="mt-2"/>
            </li>
            <li>
                <div className="float-left w-32">
                    <SelectField
                        id="state"
                        label="State*"
                        onChange={handleChange}
                        error={touched.state && errors.state}
                        value={values.state}
                        inputClassName="w-full"
                        className="mt-2">
                        <option selected="selected" value="">Select one</option>
                        {usStateList.map( st => <option value={st.abbreviation}>{st.abbreviation}</option> )}
                    </SelectField>
                </div>
                <div className="float-left ml-8 w-32">
                    <TextField
                        id="postalCode"
                        label="ZIP Code*"
                        onChange={handleChange}
                        minLength="5"
                        maxLength="10"
                        error={touched.postalCode && errors.postalCode}
                        value={values.postalCode}
                        inputClassName="w-full digits"
                        className="mt-2"/>
                </div>
            </li>
        </ol>
    </fieldset>;

export default AddressFormFields;